import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const EngineHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-4 tracking-tight text-white">
          Custom Training Built for the Modern Enterprise
        </h1>
        
        <p className="text-lg text-gray-400 mb-8">
          Powered by Traain's Navigator AI™
        </p>
        
        <div className="max-w-4xl mx-auto space-y-4 mb-8">
          <p className="text-xl text-gray-300">
            Workforces are more distributed, dynamic, and global than ever before.
          </p>
          <p className="text-xl text-cyan-400 font-semibold">
            Training must move at the same speed.
          </p>
        </div>
        
        <p className="text-lg text-gray-400 max-w-3xl mx-auto mb-12">
          Traain Engine delivers AI-powered Training designed for today's fractionated workplace — helping enterprises create consistency, confidence, and execution at scale.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            onClick={openCalendly}
            className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            data-testid="engine-hero-demo-btn"
          >
            Schedule a Discovery Call
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default EngineHero;
